<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 class="modal-title"><i class="fal fa-home"></i> Convert Rental to Multi-Unit</h5>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body p-0">
  <div class="d-flex align-items-start gap-3 p-3" style="background: #fcfcfd">
    <img src="/assets/images/rental-group/multi-unit-2.svg" alt="" width="100" />
    <div class="flex-1">
      <h6 i18n class="mb-1">Convert a Rental into a Multi-Unit Setup</h6>
      <div i18n class="text-sm text-muted">
        Turn a single rental into multiple bookable subunits under one main listing. Each subunit will have its own
        pricing, availability, and details, while the main unit itself remains unbookable.
      </div>

      <div class="alert alert-secondary-warning2 text-warning2 mb-0 mt-1 p-2">
        <div i18n class="text-semi-bold">For example:</div>
        <div i18n>
          A hotel floor with 10 identical deluxe rooms can be listed as a Multi-Unit rental, where each room is booked
          separately
        </div>
      </div>
    </div>
  </div>
  <div class="p-3 border-top border-bottom">
    <form [formGroup]="form" class="row">
      <div class="col-md-8">
        <mat-form-field2
          class="mat-block"
          matTooltip="Set a name prefix for the subunits. This helps identify them under the main unit when converted to a multi-unit listing across all channels"
          i18n-matTooltip
        >
          <mat-label>
            <ng-container i18n>Subunit Name Prefix</ng-container>&nbsp; <i class="far fa-question-circle"></i>
          </mat-label>
          <input
            type="text"
            formControlName="name"
            matInput
            required
            placeholder="Subunit Name Prefix"
            i18n-placeholder
            autocomplete="off"
          />
          <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
            Name is required
          </mat-error>
          <mat-error *ngIf="form.get('name').hasError('allNumbers')" i18n> Name cannot be numbers alone. </mat-error>
          <mat-error *ngIf="form.get('name').hasError('allSpaces')" i18n> Name cannot be spaces alone. </mat-error>
          <mat-error *ngIf="form.get('name').hasError('minlength')">
            Name must be at least 2 characters long
          </mat-error>
          <mat-error *ngIf="form.get('name').hasError('maxlength')" i18n>
            Name must be at most 140 characters long
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-4">
        <mat-form-field2
          class="mat-block"
          matTooltip="Enter the number of subunits you want to create under this listing. This will convert the rental into a multi-unit setup in AdvanceCM and other connected channels."
          i18n-matTooltip
        >
          <mat-label>
            <ng-container i18n>Number of Units</ng-container>&nbsp; <i class="far fa-question-circle"></i>
          </mat-label>
          <input
            type="number"
            formControlName="count"
            matInput
            required
            i18n-placeholder
            placeholder="Number of Units"
          />
          <mat-error *ngIf="form.get('count').touched && form.get('count').hasError('required')" i18n>
            Number is required
          </mat-error>
          <mat-error *ngIf="form.get('count').hasError('integer')" i18n> Number should be integer </mat-error>
          <mat-error *ngIf="form.get('count').hasError('min')" i18n> Min value is 1 </mat-error>
          <mat-error *ngIf="form.get('count').hasError('max')" i18n> Max value is 100 </mat-error>
        </mat-form-field2>
      </div>
    </form>
  </div>

  <div class="p-3" style="background: #fcfcfd">
    <div i18n>Preview:</div>
    <ul
      class="list-unstyled d-grid mb-0 overflow-auto"
      style="gap: 1px; max-height: 200px; grid-template-columns: repeat(3, 1fr)"
    >
      <li
        class="d-flex align-items-center gap-2 position-relative bg-active text-truncate justify-content-end"
        #parentRow
        style="min-height: 30px; padding: 0 25px 0; direction: rtl"
      >
        <app-rental-group-label
          label="Multi"
          labelClass="bg-indigo text-white"
          [height]="parentRow.offsetHeight"
          class="position-absolute fw-normal"
          [style.left.px]="-7"
        ></app-rental-group-label>
        <div class="text-truncate">
          {{ mainRental?.id | rentalName | async }}
          <span i18n class="text-light text-sm">(Main Unit)</span>
        </div>
      </li>
      <li
        *ngFor="let name of getChildItemNames()"
        class="d-flex align-items-center gap-2 position-relative bg-default text-truncate justify-content-end"
        #childRow
        style="min-height: 30px; padding: 0 25px 0; direction: rtl"
      >
        <app-rental-group-label
          label="Sub"
          labelClass="text-indigo bg-secondary-indigo"
          [height]="childRow.offsetHeight"
          class="position-absolute fw-normal"
          [style.left.px]="-7"
        ></app-rental-group-label>
        <div class="text-truncate">{{ name }}</div>
      </li>
    </ul>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    Cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="loading$ | async">
    <span class="cs-icon cs-icon-refresh" *ngIf="!(loading$ | async)"></span>
    <span class="far fa-spinner fa-spin" *ngIf="loading$ | async"></span>
    Convert
  </button>
</div>
